<template>
  <div class="component category-list">
    <ol>
      <li v-for="(item, index) in items" :key="index">
        <router-link :to="{ name: `${type}-items`, params: { category: item.id }}">
        <div class="thumb">
          <img :src="item.imageUrl" alt="{Activity image caption}" class="image">
          <div class="info">
            <div class="name">{{ item.name }}</div>
          </div>
        </div>

      </router-link>
      </li>
    </ol>
  </div>
</template>

<script>
import moment from 'moment';
import Category from '@/models/Category';
import dateItem from '@/mixins/dateItem';

export default {
  mixins: [ dateItem ],

  props: ['type'],

  created() {
    this.load();
  },

  computed: {
    items() {
      return Category.query().where('type', this.type).orderBy('webSortPriority', 'asc').get();
    }
  },

  watch: {
    '$route': 'routeChanged'
  },

  methods: {
    routeChanged() {
      this.load();
    },

    load() {
      // this.$store.dispatch(`${this.type}/fetchCategories`);
      let date = moment(this.activeDate).format('YYYY-MM-DD');

      Category.fetchCategories(this.type, date);
    },

    routeLink(item) {
      // return `/${this.type}/?category=${item.id}`;
      return { name: this.type, query: { category: item.id }};
    }
  }
}
</script>

<style lang="scss">
.component.category-list {
  @include grid-list;

  @include breakpoint(medium) {
    margin: 0 -8px;
  }

  .thumb {
    height: 0;
    overflow: hidden;
    background: #fff;
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    color: #fff;
    @include breakpoint(medium) {
      padding-top: 75%;
    }

    .image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .info {
      @include center-xy();
      position: absolute;
      width: 100%;
      padding: 25px;
      text-align: center;
      text-shadow: 0 1px 2px rgba(0,0,0,.8);
      z-index: 1;
    }

    .name {
      font-size: 26px;
      line-height: 30px;

      @include breakpoint(medium) {
        font-size: 24px;
        line-height: 28px;
      }
    }

    .count {
      @include font-small;
      margin-top: 5px;
    }

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to top, #0000004d, #0000001a 100%);
      z-index: 1;
    }

    &:hover::before {
      background-color: rgba(0,0,0,.12);
    }

  }

}

</style>